export const API_PATH = 'https://meichu.games/api'

export const YEAR_ID = 1

export const GAME_TYPE_OF = {
    'official': '正式賽',
    'exhibition': '表演賽',
    'friendly': '友誼賽',
    'agenda': '非賽事'
}

export const GAME_STATUS = {
    'nonstrt': '未開始',
    'preparation': '準備中',
    'running': '進行中',
    'pause': '暫停中',
    'nctu': '陽明交大勝',
    'nthu': '清大勝',
    'draw': '平手',
    'end': '已結束',
    'stop': '因故停賽',
    'other': '其他',
}

export const NEWS_TYPE_OF = {
    'news': '新聞',
    'activity': '活動',
    'game': '賽事公告',
    'link': '連結',
    'other': '其他'
}